export default {
    auditAssignment: {
        pendingSubmission: 2,
        submitted: 3,
    },
    exclusionReason: {
        assetIsSold: 2,
        assetDeliveredToCustomerAndNotPaid: 11,
    },
};
